import { createFileRoute } from "@tanstack/react-router";

import { SaudeComProposito } from "@/components/itv/pages/SaudeComProposito";
import { carregarPaginaSimples } from "@/lib/pagina-simples";

const PATH = "/saude-com-proposito/";
const TITLE = "Método SP: Saúde com Propósito | Dr. Thiago Viana";
const DESCRIPTION =
  "Conheça o Método SP: sete pilares integrados da alimentação ao propósito de vida para investigar causas e transformar sua rotina com suporte médico.";

export const Route = createFileRoute("/saude-com-proposito")({
  loader: () => carregarPaginaSimples(PATH, TITLE, DESCRIPTION),
  head: ({ loaderData }) => ({
    meta: loaderData?.meta ?? [],
    links: loaderData?.links ?? [],
  }),
  component: Page,
});

function Page() {
  return <SaudeComProposito />;
}
